<template>
  <div class="customer-profiling-details-bets-table-cell customer-profiling-details-bets-table-cell--is-flag-cell">
    <Dropdown
      v-if="!bet.isBetPart"
      :icon="isFlagged ? 'flag-fill' : 'flag'"
      :class="['flag-dropdown', flagType.toLowerCase()]"
      :calculate-position="false"
      @click.stop
    >
      <DropdownItem
        v-for="label in Object.values(profilingLabels)"
        :key="label.value"
        @click="setFlagType(label.value)"
        clickable
      >
        <div class="dropdown-item-content">
          <Icon
            :name="label.value === 'DEFAULT' ? 'flag' : 'flag-fill'"
            :class="['flag-icon', `flag-icon--${label.value.toLowerCase()}`]"
          />
          <span>{{ label.title }}</span>
        </div>
      </DropdownItem>
    </Dropdown>
  </div>
</template>

<script>
import { get } from 'lodash';
import { computed } from 'vue';
import { useStore } from 'vuex';
import Icon from '@/components/common/Icon';
import Dropdown from '@/components/common/Dropdown';
import DropdownItem from '@/components/common/DropdownItem';

const profilingLabels = {
  DEFAULT: {
    value: 'DEFAULT',
    title: 'No flag',
  },
  RECREATIONAL: {
    value: 'RECREATIONAL',
    title: 'Recreational',
  },
  STEAM: {
    value: 'STEAM',
    title: 'Steam',
  },
  SCALP: {
    value: 'SCALP',
    title: 'Scalp',
  },
  SHARP: {
    value: 'SHARP',
    title: 'Sharp',
  },
  PAST_POST: {
    value: 'PAST_POST',
    title: 'Past Post',
  },
};

export default {
  components: {
    Icon,
    Dropdown,
    DropdownItem,
  },
  props: {
    columnKey: {
      type: String,
      required: true,
    },
    field: {
      type: String,
      required: true,
    },
    bet: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();

    const isFlagged = computed(() => get(props.bet, props.field));
    const flagType = computed(() => props.bet.flagType || 'DEFAULT');

    const setFlagType = (type) => {
      store.dispatch('betTicker/applyCustomerBetFlag', {
        betId: props.bet.betId,
        isFlagged: isFlagged.value,
        flagType: type,
      });
    };

    return {
      isFlagged,
      flagType,
      profilingLabels,
      setFlagType,
    };
  },
};
</script>

<style lang="scss">
.customer-profiling-details-bets-table-cell {
  &--is-flag-cell {
    display: flex;
    align-items: center;
    overflow: visible;

    .flag-dropdown {
      cursor: pointer;
      z-index: 10;

      &:focus-within,
      &:hover {
        z-index: 11;
      }

      &:has(.dropdown-menu) {
        z-index: 11;
      }

      .dropdown-button__icon {
        &:not(.dropdown-button__icon--chevron) {
          stroke: inherit;

          &.icon {
            width: 14px;
            height: 14px;
          }
        }
      }

      // Color states for the main dropdown button
      &.recreational .dropdown-button__icon--left { svg { path { fill: #00BC57; }} }
      &.steam .dropdown-button__icon--left { svg { path { fill: #175FFF; }} }
      &.scalp .dropdown-button__icon--left { svg { path { fill: #FF9431; }} }
      &.sharp .dropdown-button__icon--left { svg { path { fill: #FFEA31; }} }
      &.past_post .dropdown-button__icon--left { svg { path { fill: #FF2E2D; }} }

      .button.button--secondary.dropdown-button {
        padding: 12px 4px;
        .dropdown-button__icon--chevron {
          margin-left: 4px;
          stroke: #000000;
        }
      }
    }

    .dropdown-item-content {
      display: flex;
      gap: 8px;
      align-items: center;
      font-weight: 400;

      .flag-icon {
        width: 14px;
        height: 14px;

        &--default {
          fill: none;
        }

        &--recreational {
          svg {
            path {
              fill: #00BC57;
            }
          }
        }

        &--steam {
          svg {
            path {
              fill: #175FFF;
            }
          }
        }

        &--scalp {
          svg {
            path {
              fill: #FF9431;
            }
          }
        }

        &--sharp {
          svg {
            path {
              fill: #FFEA31;
            }
          }
        }

        &--past_post {
          svg {
            path {
              fill: #FF2E2D;
            }
          }
        }
      }
    }
  }
}
</style>
